// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__ImyXX","text":"Breadcrumbs_text__PPf8M","text__dash":"Breadcrumbs_text__dash__QYWDo"};